<template>
  <div class="content">
    <div class="text">
      <p class="title" id="title">{{ title }}</p>
      <p
        class="desc"
        v-for="(item, index) in desc"
        :key="index"
      >
        {{ item.text }}
      </p>
      <!-- <div class="btn">
        <img src="@/assets/images/gp.png" class="btn" @click.stop="gpAction(false)"/>
        <img src="@/assets/images/ios.png" class="btn ios" @click.stop="gpAction(true)" alt="">
      </div> -->
      <div class="btns">
        <div class="btn">
          <img src="@/assets/images/gp.png" @click.stop="gpAction(false)"/>
        </div>
      </div>
    </div>
    <!-- <img src="@/assets/images/screen.jpg" class="phone" /> -->
    <div class="title" style="margin-top: 30px;">Why Choose VidGen?</div>
    <img src="@/assets/images/banner.png" class="banner" />
    <div class="features">
      <ul>
        <li><svg t="1764951679535" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6134" width="200" height="200"><path d="M477.128795 92.616374c18.909675-40.042995 49.857525-40.042995 68.766177 0l81.909521 173.405375c18.908652 40.037878 70.39835 78.265528 114.396423 84.943624l176.929642 26.855648c43.99705 6.677073 54.562686 38.043455 23.487947 69.702502L811.825646 580.719104c-31.097252 31.661094-50.659797 93.284593-43.496653 136.935766l31.508621 191.861726c7.164167 43.657312-18.842137 61.867046-57.800427 40.46255l-159.698189-87.727017c-38.959314-21.394263-102.70208-21.394263-141.661394 0L280.972253 949.979146c-38.951127 21.405519-64.968687 3.196809-57.795311-40.46255l31.489178-191.861726c7.173376-43.651173-12.402471-105.276718-43.488467-136.935766L80.409354 447.526593c-31.085996-31.659047-20.520359-63.028499 23.483854-69.704548L280.81978 350.966397c44.00319-6.67605 95.483678-44.905746 114.393353-84.942601L477.128795 92.616374 477.128795 92.616374z" fill="#9135a5" p-id="6135"></path></svg>Core AI Generation: Seamlessly supports Text-to-Video, Image-to-Video, Text-to-Image, and Image-to-Image workflows.</li>
        <li><svg t="1764951679535" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6134" width="200" height="200"><path d="M477.128795 92.616374c18.909675-40.042995 49.857525-40.042995 68.766177 0l81.909521 173.405375c18.908652 40.037878 70.39835 78.265528 114.396423 84.943624l176.929642 26.855648c43.99705 6.677073 54.562686 38.043455 23.487947 69.702502L811.825646 580.719104c-31.097252 31.661094-50.659797 93.284593-43.496653 136.935766l31.508621 191.861726c7.164167 43.657312-18.842137 61.867046-57.800427 40.46255l-159.698189-87.727017c-38.959314-21.394263-102.70208-21.394263-141.661394 0L280.972253 949.979146c-38.951127 21.405519-64.968687 3.196809-57.795311-40.46255l31.489178-191.861726c7.173376-43.651173-12.402471-105.276718-43.488467-136.935766L80.409354 447.526593c-31.085996-31.659047-20.520359-63.028499 23.483854-69.704548L280.81978 350.966397c44.00319-6.67605 95.483678-44.905746 114.393353-84.942601L477.128795 92.616374 477.128795 92.616374z" fill="#9135a5" p-id="6135"></path></svg>Top-Tier Models: Powered by industry-leading AI models including Nano Banana, PixVerse, and Seedream for unmatched clarity and coherence.</li>
        <li><svg t="1764951679535" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6134" width="200" height="200"><path d="M477.128795 92.616374c18.909675-40.042995 49.857525-40.042995 68.766177 0l81.909521 173.405375c18.908652 40.037878 70.39835 78.265528 114.396423 84.943624l176.929642 26.855648c43.99705 6.677073 54.562686 38.043455 23.487947 69.702502L811.825646 580.719104c-31.097252 31.661094-50.659797 93.284593-43.496653 136.935766l31.508621 191.861726c7.164167 43.657312-18.842137 61.867046-57.800427 40.46255l-159.698189-87.727017c-38.959314-21.394263-102.70208-21.394263-141.661394 0L280.972253 949.979146c-38.951127 21.405519-64.968687 3.196809-57.795311-40.46255l31.489178-191.861726c7.173376-43.651173-12.402471-105.276718-43.488467-136.935766L80.409354 447.526593c-31.085996-31.659047-20.520359-63.028499 23.483854-69.704548L280.81978 350.966397c44.00319-6.67605 95.483678-44.905746 114.393353-84.942601L477.128795 92.616374 477.128795 92.616374z" fill="#9135a5" p-id="6135"></path></svg>Static to Dynamic: Breathe life into your still photos. Our Image-to-Video feature creates smooth, realistic motion from any picture.</li>
        <li><svg t="1764951679535" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6134" width="200" height="200"><path d="M477.128795 92.616374c18.909675-40.042995 49.857525-40.042995 68.766177 0l81.909521 173.405375c18.908652 40.037878 70.39835 78.265528 114.396423 84.943624l176.929642 26.855648c43.99705 6.677073 54.562686 38.043455 23.487947 69.702502L811.825646 580.719104c-31.097252 31.661094-50.659797 93.284593-43.496653 136.935766l31.508621 191.861726c7.164167 43.657312-18.842137 61.867046-57.800427 40.46255l-159.698189-87.727017c-38.959314-21.394263-102.70208-21.394263-141.661394 0L280.972253 949.979146c-38.951127 21.405519-64.968687 3.196809-57.795311-40.46255l31.489178-191.861726c7.173376-43.651173-12.402471-105.276718-43.488467-136.935766L80.409354 447.526593c-31.085996-31.659047-20.520359-63.028499 23.483854-69.704548L280.81978 350.966397c44.00319-6.67605 95.483678-44.905746 114.393353-84.942601L477.128795 92.616374 477.128795 92.616374z" fill="#9135a5" p-id="6135"></path></svg>Creative Variety: Access over 90 distinct art styles and filters. From anime to photorealism, find the perfect look for your story.</li>
        <li><svg t="1764951679535" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6134" width="200" height="200"><path d="M477.128795 92.616374c18.909675-40.042995 49.857525-40.042995 68.766177 0l81.909521 173.405375c18.908652 40.037878 70.39835 78.265528 114.396423 84.943624l176.929642 26.855648c43.99705 6.677073 54.562686 38.043455 23.487947 69.702502L811.825646 580.719104c-31.097252 31.661094-50.659797 93.284593-43.496653 136.935766l31.508621 191.861726c7.164167 43.657312-18.842137 61.867046-57.800427 40.46255l-159.698189-87.727017c-38.959314-21.394263-102.70208-21.394263-141.661394 0L280.972253 949.979146c-38.951127 21.405519-64.968687 3.196809-57.795311-40.46255l31.489178-191.861726c7.173376-43.651173-12.402471-105.276718-43.488467-136.935766L80.409354 447.526593c-31.085996-31.659047-20.520359-63.028499 23.483854-69.704548L280.81978 350.966397c44.00319-6.67605 95.483678-44.905746 114.393353-84.942601L477.128795 92.616374 477.128795 92.616374z" fill="#9135a5" p-id="6135"></path></svg>Bulk Creation: Need content fast? Use our Batch Processing feature to generate multiple videos and images simultaneously.</li>
        <li><svg t="1764951679535" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6134" width="200" height="200"><path d="M477.128795 92.616374c18.909675-40.042995 49.857525-40.042995 68.766177 0l81.909521 173.405375c18.908652 40.037878 70.39835 78.265528 114.396423 84.943624l176.929642 26.855648c43.99705 6.677073 54.562686 38.043455 23.487947 69.702502L811.825646 580.719104c-31.097252 31.661094-50.659797 93.284593-43.496653 136.935766l31.508621 191.861726c7.164167 43.657312-18.842137 61.867046-57.800427 40.46255l-159.698189-87.727017c-38.959314-21.394263-102.70208-21.394263-141.661394 0L280.972253 949.979146c-38.951127 21.405519-64.968687 3.196809-57.795311-40.46255l31.489178-191.861726c7.173376-43.651173-12.402471-105.276718-43.488467-136.935766L80.409354 447.526593c-31.085996-31.659047-20.520359-63.028499 23.483854-69.704548L280.81978 350.966397c44.00319-6.67605 95.483678-44.905746 114.393353-84.942601L477.128795 92.616374 477.128795 92.616374z" fill="#9135a5" p-id="6135"></path></svg>Always On: Reliable 24/7 service ensures you can create whenever inspiration strikes.</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      desc: [],
      screen: "",
    };
  },
  computed: {
    textColor: function() {
      return this.$store.state.data.theme.desc_color;
    },
  },
  created() {
    this.renderUI();
  },
  methods: {
    renderUI() {
      const config = this.$store.state.data;
      console.log(config);
      // this.screen = `${config.baseUrl}images/screen.png?v=${new Date().getTime()}`;
      this.screen = `${config.screen}`;
      const { title, desc } = config.page[0];
      this.title = title;
      this.desc = desc;
    },
    gpAction(isIos = false){
      // window.gtagEvent('10001')
      // alert('Coming soon')
      // if (isIos) {
      //   window.open('https://apps.apple.com/us/app/id6503810311');
      // } else {
      //   window.open('https://play.google.com/store/apps/details?id=ai.character.talkie.waifu');
      // }
      window.open('https://play.google.com/store/apps/details?id=com.ai.video.gen.maker.app');
    }
  },
};
</script>

<style lang="less">
.content {
  padding: 6px 0 28px;
  flex: 1;
  // background-image: url( "~@/assets/images/bg.png" );
  // background-color: #2e2e2e;
  background-color: #000;
  background-size: cover;
  width: 100%;
  // background-image: url( "~@/assets/images/screen.jpg" );

  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  flex-direction: column;
  .phone {
    width: 233px;
    border-radius: 3px;
  }
  .text {
    // margin-right: 56px;
    // max-width: 540px;
    max-width: 800px;
    img{
      width: 140px;
      margin-top: 12px;
    }
  }
  .title {
    font-size: 30px;
    font-family: "Momo Trust Display", Poppins, PingFangSC-Regular, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    // line-height: 38px;
    margin-bottom: 20px;
  }
  .desc {
    font-size: 14px;
    font-family: Poppins, PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 2;
    margin-bottom: 18px;
  }
  .btns{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 0;
  }
  .btn{
    cursor: pointer;
    border: 2px solid #a60ac7;
    border-radius: 30px;
    img{
      width: 140px;
      margin-top: 6px;
    }
    &:hover{
      border-color: #c80af0;
    }
    // &.ios{
    //   height: 36px;
    //   width: auto;
    //   margin-left: 30px;
    // }
  }
}
.banner{
  max-width: 800px;
  margin-top: 10px;
  margin-bottom: 30px;
}
.features{
  max-width: 800px;
  ul{
    margin-top: 0;
    padding-left: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
    li{
      color: #adb7be;
      list-style: none;
      font-size: 14px;
      display: flex;
      align-items: center;
      // ::v-deep{
        svg{
          width: 16px;
          height: 16px;
          margin-right: 8px;
        }
      // }
    }
  }
}
</style>
